<div class="twc-container twc-m-2">
    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{ title | translate}}</h3>
    </div>

    <div class="twc-col-7 twc-col-sm-5 twc-mb-4">
        <ng-container *ngIf="!isCsvGeometry">
            <span class="twc-form-label">
                <strong>{{'UPLOAD.DXF_GIS_IMPORTER_SELECT_GEOMETRY_TYPE' | translate}}</strong>
            </span>

            <twc-select [(ngModel)]="gisConversion.geometryType">
                <twc-select-option [value]="'AUTODETECT'">
                    <em>{{ 'UPLOAD.DXF_GIS_IMPORTER_AUTODETECT' | translate }}</em>
                </twc-select-option>
                <twc-select-option *ngFor="let option of geometryTypes" [value]="option.key">
                    {{ option.value | translate}}
                </twc-select-option>
            </twc-select>
        </ng-container>

        <ng-container *ngIf="isCsvGeometry">
            <span class="twc-form-label">
                <strong>{{'UPLOAD.CSV_GIS_IMPORTER_SELECT_TYPE' | translate}}</strong>
            </span>

            <twc-select [(ngModel)]="gisConversion.csvType" (ngModelChange)="onGisSelectChanged()">
                <twc-select-option *ngFor="let option of csvTypes" [value]="option">
                    {{'UPLOAD.CSV_GIS_IMPORTER_CONTROL_POINT_' + option | translate }}
                </twc-select-option>
            </twc-select>
        </ng-container>
    </div>

    <div class="twc-col-7 twc-col-sm-5">
        <span class="twc-form-label">
            <strong>{{'UPLOAD.CSV_GIS_IMPORTER_SELECT_SCALE_FACTOR' | translate}}</strong>
        </span>
        <twc-select [(ngModel)]="gisConversion.ScaleFactor">
            <twc-select-option *ngFor="let option of scaleFactorDefinitions" [value]="option.fromMeters">
                {{ option.label | translate}}
            </twc-select-option>
        </twc-select>
    </div>
</div>